import { InjectionToken } from '@angular/core';

export const INDEXEDDB_TOKEN = new InjectionToken<IDBFactory>('Window IDBFactory object', {
    providedIn: 'root',
    factory: () => window.indexedDB
});